<template>
  <div class="qr-venues">
    <div class="qr-venues__header">
      <div class="qr-venues__intro">
        <h3 class="qr-venues__title">Venue Performance</h3>
        <p class="qr-venues__subtitle">Performance of each QR location.</p>
      </div>

      <div class="qr-venues__select-wrap">
        <select
          class="qr-venues__select"
          :value="venueFilter"
          @change="$emit('update:venueFilter', $event.target.value)"
        >
          <option value="all">All Venues</option>
          <option
            v-for="venue in venues"
            :key="venue.id"
            :value="venue.id"
          >
            {{ venue.name }}
          </option>
        </select>
        <feather-icon icon="ChevronDownIcon" svgClasses="qr-venues__select-icon" />
      </div>
    </div>

    <div class="qr-venues__table-wrap">
      <table class="qr-venues__table">
        <thead>
          <tr>
            <th class="qr-venues__th qr-venues__th--left">Venue</th>
            <th class="qr-venues__th">QR Opens</th>
            <th class="qr-venues__th">Bookings Made</th>
            <th class="qr-venues__th">Completed</th>
            <th class="qr-venues__th">Conversion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="venue in filteredVenues"
            :key="venue.id"
            class="qr-venues__row"
          >
            <td class="qr-venues__td qr-venues__td--venue">{{ venue.name }}</td>
            <td class="qr-venues__td">{{ formatNumber(venue.qrOpens) }}</td>
            <td class="qr-venues__td">{{ formatNumber(venue.bookingsMade) }}</td>
            <td class="qr-venues__td">{{ formatNumber(venue.completed) }}</td>
            <td class="qr-venues__td qr-venues__td--conversion">
              {{ venue.conversion.toFixed(1) }}%
            </td>
          </tr>
          <tr v-if="!filteredVenues.length">
            <td class="qr-venues__empty" colspan="5">No venues found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "QrVenuePerformance",
  props: {
    venues: { type: Array, required: true },
    venueFilter: { type: String, default: "all" },
  },
  computed: {
    filteredVenues() {
      if (this.venueFilter === "all") return this.venues;
      return this.venues.filter((v) => String(v.id) === String(this.venueFilter));
    },
  },
  methods: {
    formatNumber(value) {
      return Number(value).toLocaleString();
    },
  },
};
</script>

<style scoped lang="scss">
.qr-venues {
  background: #fff;
  border-radius: 18px;
  padding: 1.5rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
  }

  &__title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d2d2d;
    margin: 0 0 0.35rem;
  }

  &__subtitle {
    font-size: 0.8125rem;
    color: #a8a8b3;
    margin: 0;
  }

  &__select-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__select {
    appearance: none;
    background: #fff;
    border: 1px solid #e4e4e8;
    border-radius: 10px;
    min-height: 40px;
    padding: 0 2.1rem 0 0.9rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #5e5873;
    cursor: pointer;
    min-width: 140px;

    &:focus {
      outline: none;
      border-color: #c8c4f0;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.08);
    }
  }

  &__select-icon {
    position: absolute;
    right: 0.7rem;
    width: 14px;
    height: 14px;
    color: #b9b9c3;
    pointer-events: none;
  }

  &__table-wrap {
    overflow-x: auto;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    min-width: 640px;
  }

  &__th {
    text-align: right;
    font-size: 0.75rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: none;
    letter-spacing: 0;
    padding: 0.65rem 0.85rem;
    border-bottom: 1px solid #f0f0f5;

    &--left {
      text-align: left;
      padding-left: 0;
    }
  }

  &__row {
    &:not(:last-child) .qr-venues__td {
      border-bottom: 1px solid #f5f5f7;
    }
  }

  &__td {
    text-align: right;
    padding: 1rem 0.85rem;
    font-size: 0.9375rem;
    color: #4b5563;
    white-space: nowrap;

    &--venue {
      text-align: left;
      padding-left: 0;
      font-weight: 600;
      color: #1f2937;
    }

    &--conversion {
      font-weight: 700;
      color: #16a34a;
    }
  }

  &__empty {
    text-align: center;
    padding: 2rem 1rem;
    color: #9ca3af;
    font-size: 0.875rem;
  }
}
</style>
